/*
 * @Author: 317473294@qq.com
 * @Date: 2023-07-21 23:11:03
 * @LastEditTime: 2024-11-03 00:14:03
 * @LastEditors: 317473294@qq.com
 * @Description: 
 * @FilePath: /frontEnd/src/utils/tools.js
 */
/**数组里面对象排序，对象排序主要以对象里面那个字段进行排序，比如说对象里面有个sort字段，那么以sort字段排序则可*/
import {
        createKnowledge,
        getAllKnowledge,
        KnowledgeUpdata,
        deleteKnowledge,
        getCourseidAll,
        vogueFind,
      } from "@/api/knowledge.js";
export const tools = {
        //排序
        sortObj:(arr, property) => {
                return arr.sort((m, n) => m[property] - n[property])
        },
        //将数据封装成树形结构
        //测试数据：
        // list: [
        //         { 'keyid': '29', 'parentid': 0, 'name': '总裁办' },
        //         { 'keyid': '2c', 'parentid': 0, 'name': '财务部' },
        //         { 'keyid': '2d', 'parentid': '2c', 'name': '财务核算部' },
        //         { 'keyid': '2f', 'parentid': '2c', 'name': '薪资管理部' },
        //         { 'keyid': 'd2', 'parentid': 0, 'name': '技术部' },
        //         { 'keyid': 'd3', 'parentid': 'd2', 'name': 'Java研发部' },
        //         { 'keyid': 'd4', 'parentid': '2d', 'name': '前端开发部' }
        //     ]
        tranArrToTreeData:(list) => {
                const treeList = [],  // 最终要产出的树状数据的数组
                        map = {}      // 存储映射关系
                list.forEach(item => {
                        if (!item.children) {  // 如果list遍历出来的数据没有children，就给他的数据里增加一个children，并赋值一个空数组
                                item.children = []
                        }
                        map[item.keyid] = item  //这里的map是一个空对象
                        
                })

                list.forEach(item => {
                        // 对于每一个元素来说，先找它的上级
                        //    如果能找到，说明它有上级，则要把它添加到上级的children中去
                        //    如果找不到，说明它没有上级，直接添加到 treeList
                        const parent = map[item.parentid]
                        
                        if (parent) {
                                item.topid=parent.topid
                                parent.children.push(item)
                                //更新知识点数据
                                // console.log("获取知识点数据",item)
                                // KnowledgeUpdata(item).then((res) => {
                                     
                                //       });
                        } else {
                                // 如果不存在 则是顶层数
                                treeList.push(item)
                        }
                })
                return treeList
        },
        //随机26个字母,len为随机几个字母
         getRandomLetters:(len)=>{
                const letters = 'abcdefghijklmnopqrstuvwxyz0123456789';
                let randomLetters = '';
                let lens=len?len:5;
                for (let i = 0; i <lens; i++) {
                  const randomIndex = Math.floor(Math.random() * letters.length);
                  randomLetters += letters[randomIndex];
                }
                
                return randomLetters;
              },
              //本地存储
              localData:(type,logid)=>{
                if(type=="set"){
                 localStorage.setItem("logid",logid)
                }
                if(type=="get"){
                  return localStorage.getItem("logid")
                }
              },
              //
              getIp(){
                        
             
                fetch('https://api.ipify.org?format=json')
                .then(response => response.json())
                .then(json =>{
                        console.log(json.ip)
                        return json.ip;
                } 
                
                );
               
              }
}



// WEBPACK FOOTER //
// ./src/utils/tools.js